var map = {
	"./AccountContext": 3239,
	"./AccountContext.jsx": 3239,
	"./AccountInfo": 6948,
	"./AccountInfo.css": 7293,
	"./AccountInfo.jsx": 6948,
	"./AccountInfoDemo": 913,
	"./AccountInfoDemo.css": 4931,
	"./AccountInfoDemo.jsx": 913,
	"./DesignStyleSelector": 3835,
	"./DesignStyleSelector.css": 7298,
	"./DesignStyleSelector.jsx": 3835,
	"./DesignTemplateCard": 71,
	"./DesignTemplateCard.jsx": 71,
	"./DesignTemplateGrid": 6217,
	"./DesignTemplateGrid.jsx": 6217,
	"./Export  Web Development services.png": 8154,
	"./FestivalEDMs.css": 6981,
	"./FestivalEDMsSelection": 9366,
	"./FestivalEDMsSelection.jsx": 9366,
	"./FestivalSpecialEDMs": 6323,
	"./FestivalSpecialEDMs.css": 8314,
	"./FestivalSpecialEDMs.jsx": 6323,
	"./FestivalTemplateDisplay": 2945,
	"./FestivalTemplateDisplay.jsx": 2945,
	"./FontStyleSelection": 8329,
	"./FontStyleSelection.css": 2038,
	"./FontStyleSelection.jsx": 8329,
	"./FooterSection": 8807,
	"./FooterSection.jsx": 8807,
	"./Frame 5.svg": 809,
	"./Frame 6.svg": 2074,
	"./Frame 7.svg": 4779,
	"./GreenPeak Marketing.png": 6523,
	"./ImageWithAccountInfo": 2157,
	"./ImageWithAccountInfo.css": 5190,
	"./ImageWithAccountInfo.jsx": 2157,
	"./NavigationSidebar": 336,
	"./NavigationSidebar.jsx": 336,
	"./Plot  on sale.png": 1496,
	"./Plot on sale1.png": 9781,
	"./ProductTemplateDisplay": 7617,
	"./ProductTemplateDisplay.jsx": 7617,
	"./ProductsEDMs": 8562,
	"./ProductsEDMs.css": 8585,
	"./ProductsEDMs.jsx": 8562,
	"./PurchaseLogo": 8637,
	"./PurchaseLogo.css": 7222,
	"./PurchaseLogo.jsx": 8637,
	"./SelectDesign": 7756,
	"./SelectDesign.css": 6664,
	"./SelectDesign.jsx": 7756,
	"./SelectDesignPage": 662,
	"./SelectDesignPage.jsx": 662,
	"./SelectEDM": 1370,
	"./SelectEDM.css": 4068,
	"./SelectEDM.jsx": 1370,
	"./SpecialDayEDMs": 9287,
	"./SpecialDayEDMs.css": 9220,
	"./SpecialDayEDMs.jsx": 9287,
	"./SpecialDaysEDMs": 1126,
	"./SpecialDaysEDMs.css": 9991,
	"./SpecialDaysEDMs.jsx": 1126,
	"./SpecialDaysPhotoEDMs": 5286,
	"./SpecialDaysPhotoEDMs.css": 4085,
	"./SpecialDaysPhotoEDMs.jsx": 5286,
	"./UploadLogo": 935,
	"./UploadLogo.css": 7776,
	"./UploadLogo.jsx": 935,
	"./UploadLogoCard.css": 1958,
	"./VISIBEN copy.svg": 1584,
	"./VISIBEN.svg": 3937,
	"./WelcomeSection": 3932,
	"./WelcomeSection.jsx": 3932,
	"./bhaidooj1.jpg": 7322,
	"./bhaidooj2.jpg": 9925,
	"./bhaidooj3.jpg": 7560,
	"./bhaidooj4.jpg": 235,
	"./car copy 2.jpg": 8220,
	"./car repair.png": 2722,
	"./car.jpg": 9725,
	"./car1 copy.jpg": 834,
	"./car1.jpg": 8980,
	"./car2 copy.jpg": 4320,
	"./car2.jpg": 611,
	"./car3 copy.jpg": 2115,
	"./car3.jpg": 7446,
	"./car4 copy.jpeg": 1987,
	"./car4.jpeg": 6994,
	"./car5 copy.jpg": 161,
	"./car5.jpg": 9680,
	"./car6 copy.jpg": 9356,
	"./car6.jpg": 3295,
	"./christmas-merry-christmas.jpg": 860,
	"./components/DesignCard": 1070,
	"./components/DesignCard.jsx": 1070,
	"./components/DesignGrid": 8536,
	"./components/DesignGrid.jsx": 8536,
	"./components/SelectDesignSection": 2711,
	"./components/SelectDesignSection.jsx": 2711,
	"./components/Template1Footer": 354,
	"./components/Template1Footer.jsx": 354,
	"./components/Template5And6Redesign": 3885,
	"./components/Template5And6Redesign.jsx": 3885,
	"./components/Template6Footer": 2361,
	"./components/Template6Footer.jsx": 2361,
	"./components/TemplateFooter": 7493,
	"./components/TemplateFooter.jsx": 7493,
	"./components/TemplateFooterVariants": 5587,
	"./components/TemplateFooterVariants.jsx": 5587,
	"./components/WelcomeSection": 1523,
	"./components/WelcomeSection.jsx": 1523,
	"./components/temp_header.txt": 5952,
	"./crackers copy.jpg": 5710,
	"./crackers.jpg": 2501,
	"./dhanteras1.jpg": 5648,
	"./dhanteras2.jpg": 9263,
	"./dhanteras3.jpg": 1330,
	"./dhanteras4.jpg": 9345,
	"./digital market agency.png": 7226,
	"./diwali.jpg": 5603,
	"./diwali1.jpeg": 9851,
	"./diwali1.png": 4378,
	"./diwali2.jpeg": 9582,
	"./diwali2.jpg": 9321,
	"./diwali2.png": 4545,
	"./diwali3.jpeg": 1541,
	"./diwali3.png": 328,
	"./diwali4.jpeg": 176,
	"./dussehra.jpg": 6608,
	"./dussehra1.jpg": 679,
	"./dussehra2.jpg": 5928,
	"./dussehra3.jpg": 9445,
	"./hand copy.jpg": 2705,
	"./hand.jpg": 6592,
	"./happy-diwali1.jpg": 6207,
	"./happy-holi.jpg": 4234,
	"./happy-navratri.jpg": 9207,
	"./holi-design2.jpg": 114,
	"./holi3.jpg": 1566,
	"./holi4.jpg": 4037,
	"./home copy.jpg": 4947,
	"./home.jpg": 6694,
	"./navratri1.jpg": 9979,
	"./navratri2.jpg": 7996,
	"./navratri3.jpg": 1430,
	"./selectDesignMockData": 1747,
	"./selectDesignMockData.js": 1747,
	"./teach1.jpeg": 6092,
	"./teach2.jpeg": 8973,
	"./teach3.jpeg": 7638,
	"./teach4.jpeg": 1471,
	"./vishwakarma1.jpg": 39,
	"./vishwakarma2.jpg": 6579,
	"./vishwakarma3.jpg": 118,
	"./vishwakarma4.jpg": 4877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7015;